module.exports = __webpack_public_path__ + "img/game_detail_lucky5_express.defbbc7b.jpg";